import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import { addToast } from 'containers/Toasts/actions'

import {
  assignToCompaniesError,
  assignToCompaniesSuccess,
  fetchCompaniesDataError,
  fetchCompaniesDataSuccess,
} from './actions'
import {
  ASSIGN_REQUEST_ASYNC,
  ASSIGNED_FILTER_CHANGE,
  COMPANIES_DATA_REQUEST_ASYNC,
  FILTERS_SUBMIT,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SORT_PROPERTY_CHANGE,
} from './constants'

const fetchCompaniesEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      COMPANIES_DATA_REQUEST_ASYNC.INITIATE,
      ASSIGN_REQUEST_ASYNC.SUCCESS,
      SORT_PROPERTY_CHANGE,
      FILTERS_SUBMIT,
      ASSIGNED_FILTER_CHANGE,
      PAGINATE_CHANGE,
      SEARCH_CHANGE
    ),
    mergeMap(() =>
      api.groupSettings
        .getGroupSettingsCompanies(
          state$.value.groupsettings.assign.groupSettings?.id,
          state$.value.groupsettings.assign.page,
          state$.value.groupsettings.assign.sortProperty,
          state$.value.groupsettings.assign.filters?.emailIntegrationFilter,
          state$.value.groupsettings.assign.filters?.groupSettingsFilter,
          state$.value.groupsettings.assign.filters?.assignedFilter,
          state$.value.groupsettings.assign.search,
          state$.value.partnerOptions.selectedCompany?.value
        )
        .pipe(
          map((response) => fetchCompaniesDataSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchCompaniesDataError, error))),
          takeUntil(action$.pipe(ofType(COMPANIES_DATA_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const assignGroupSettingsToCompaniesEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(ASSIGN_REQUEST_ASYNC.INITIATE),
    mergeMap(() =>
      api.groupSettings
        .assignGroupSettingsToCompanies(state$.value.partnerOptions.selectedCompany?.value, {
          groupSettingsId: state$.value.groupsettings.assign.groupSettings?.id,
          companiesList: Object.keys(state$.value.groupsettings.assign.selectedCompaniesMap),
          selectAll: state$.value.groupsettings.assign.selectAll,
          search: state$.value.groupsettings.assign.search,
          emailIntegrationFilter: state$.value.groupsettings.assign.filters?.emailIntegrationFilter,
          groupSettingsFilter: state$.value.groupsettings.assign.filters?.groupSettingsFilter,
          assignedFilter: state$.value.groupsettings.assign.filters?.assignedFilter,
        })
        .pipe(
          map((response) => assignToCompaniesSuccess(response)),
          catchError((error) =>
            of(
              epicsErrorHandler(assignToCompaniesError, error),
              addToast({
                message: error.response?.message || error?.response,
                type: 'error',
              })
            )
          ),
          takeUntil(action$.pipe(ofType(ASSIGN_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(assignGroupSettingsToCompaniesEpic, fetchCompaniesEpic)
